import React from 'react';
import "./Banner.css"

const Banner = () => {
    return (
        <div className="banner">
            <div className="hallname">
                <h1 className="my-4">Shaheed Abdur Rab Hall</h1>
                <h5>Since 1994</h5>
            </div>
        </div>
    );
};

export default Banner;